import React from 'react';

const options = [
  {
    id: '1',
    name: 'Org Members Only',
    value: false,
  },
  {
    id: '2',
    name: 'Everyone',
    value: true,
  },
];

const Visibility = ({
  selected,
  onChange,
}) => {
  const selectedLabel = options.filter(option => option.value === selected)[0].name;
  return (
    <div name="visibility">
      <div name="label">Visibility:</div>
      <div className="ChecklistItemDetailSelect"
        style={{ position: 'relative', display: 'inline-block', overflow: 'hidden' }}
      >
        <span className="label">{selectedLabel}</span>
        <select
          value={selected}
          onChange={onChange}
          style={{ opacity: 0, position: 'relative', zIndex: 1, margin: 0 }}
        >
          {options?.map(item => (
            <option key={item.id}
              value={item.value}
            >{item.name}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default Visibility;
